import axios from '../plugins/axios';

const API_URL = '/admin/courses';

export default {
  async getCourses(filters = {}) {
    try {
      let url = API_URL;
      
      // Add query parameters for filtering if needed
      if (Object.keys(filters).length > 0) {
        const queryParams = [];
        
        for (const key in filters) {
          queryParams.push(`${key}=${encodeURIComponent(filters[key])}`);
        }
        
        url += `?${queryParams.join('&')}`;
      }
      
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  },
  
  async createCourse(data) {
    try {
      // Ensure numeric fields are properly formatted
      if (data.price_per_person) {
        data.price_per_person = parseFloat(data.price_per_person);
      }
      
      if (data.capacity) {
        data.capacity = parseInt(data.capacity);
      }
      
      const response = await axios.post(API_URL, data);
      return response.data;
    } catch (error) {
      console.error('Error creating course:', error);
      throw error;
    }
  },
  
  async updateCourse(id, data) {
    try {
      // Ensure numeric fields are properly formatted
      if (data.price_per_person) {
        data.price_per_person = parseFloat(data.price_per_person);
      }
      
      if (data.capacity) {
        data.capacity = parseInt(data.capacity);
      }
      
      const response = await axios.put(`${API_URL}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating course:', error);
      throw error;
    }
  },
  
  async deleteCourse(id) {
    try {
      const response = await axios.delete(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting course:', error);
      throw error;
    }
  },
  
  async getCourseById(id) {
    try {
      const response = await axios.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching course:', error);
      throw error;
    }
  }
}; 